import React, { useRef } from "react";
import { observer } from "mobx-react";
import { Grid, Box } from "@mui/material";
import { GroupContainer } from "../../../../common/components";
import { FormToolbox } from "../../../../common/controls/forms/FormToolbox";
import { useReactToPrint } from "react-to-print";

import { useRootStore } from "../../../../store/contexts";
import { ShowDateTime } from "../../../common/controls";
import { ShowMultiLine } from "../../../common/controls";
import { ShowNumber } from "../../../common/controls";
import { InputCodeEditor } from "../../../common/controls";
import { ShowReference } from "../../../common/controls";
import { FormControl } from "@mui/material";

export type SatelliteHeartbeatViewFormProps = {
  onPrint?: (handlePrint: () => void) => void;
  onCancel?: () => void;
  onEdit?: () => void;
  showToolbox?: boolean;
  receivedAtValue?: { displayId: string; id: string } | null;
  receivedAt: Date | null;
  publicIpValue?: { displayId: string; id: string } | null;
  publicIp: string;
  latencyValue?: { displayId: string; id: string } | null;
  latency: number | undefined;
  cpuUsageValue?: { displayId: string; id: string } | null;
  cpuUsage: number | undefined;
  memoryUsageValue?: { displayId: string; id: string } | null;
  memoryUsage: number | undefined;
  diskUsageValue?: { displayId: string; id: string } | null;
  diskUsage: number | undefined;
  activeTasksCountValue?: { displayId: string; id: string } | null;
  activeTasksCount: number | undefined;
  proxyStatsValue?: { displayId: string; id: string } | null;
  proxyStats: string;
  systemInfoValue?: { displayId: string; id: string } | null;
  systemInfo: string;
  satelliteMachineValue: { displayId: string; id: string } | null;
};

export const SatelliteHeartbeatViewForm: React.FC<SatelliteHeartbeatViewFormProps> =
  observer(
    ({
      onPrint = () => {},
      onCancel = () => {},
      onEdit,
      showToolbox = true,
      receivedAt = null,
      publicIp = "",
      latency = 0,
      cpuUsage = 0,
      memoryUsage = 0,
      diskUsage = 0,
      activeTasksCount = 0,
      proxyStats = "{}",
      systemInfo = "{}",
      satelliteMachineValue,
    }) => {
      const rootStore = useRootStore();
      const { langStore } = rootStore;

      const componentRef = useRef(null);
      const handlePrint = useReactToPrint({
        content: () => componentRef.current,
      });

      return (
        <Grid>
          {showToolbox && (
            <FormToolbox
              editForm={onEdit}
              printForm={() => onPrint(handlePrint)}
              closeForm={() => onCancel()}
            />
          )}
          <Box ref={componentRef}>
            <GroupContainer
              id="null"
              title={langStore.groupSatelliteHeartbeatLabel}
              collapsible={false}
            >
              <FormControl fullWidth>
                <ShowDateTime
                  value={receivedAt}
                  label={langStore.SatelliteHeartbeatReceivedAtLabel}
                />
                <ShowMultiLine
                  value={publicIp}
                  label={langStore.SatelliteHeartbeatPublicIpLabel}
                />
                <ShowNumber
                  value={latency}
                  label={langStore.SatelliteHeartbeatLatencyLabel}
                />
                <ShowNumber
                  value={cpuUsage}
                  label={langStore.SatelliteHeartbeatCpuUsageLabel}
                  decimalScale={2}
                />
                <ShowNumber
                  value={memoryUsage}
                  label={langStore.SatelliteHeartbeatMemoryUsageLabel}
                  decimalScale={2}
                />
                <ShowNumber
                  value={diskUsage}
                  label={langStore.SatelliteHeartbeatDiskUsageLabel}
                  decimalScale={2}
                />
                <ShowNumber
                  value={activeTasksCount}
                  label={langStore.SatelliteHeartbeatActiveTasksCountLabel}
                />
                <InputCodeEditor
                  value={proxyStats}
                  onChange={() => {}}
                  label={langStore.SatelliteHeartbeatProxyStatsLabel}
                  language="json"
                  readOnly={true}
                />
                <InputCodeEditor
                  value={systemInfo}
                  onChange={() => {}}
                  label={langStore.SatelliteHeartbeatSystemInfoLabel}
                  language="json"
                  readOnly={true}
                />
                <ShowReference
                  label={langStore.SatelliteHeartbeatSatelliteMachineLabel}
                  selectedValue={langStore.displayIdByLang(
                    satelliteMachineValue?.displayId
                  )}
                />
              </FormControl>
            </GroupContainer>
          </Box>
        </Grid>
      );
    }
  );
